import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "q-pa-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-weight-bold q-mb-sm" }, " Account Handle ", -1)
const _hoisted_3 = {
  key: 0,
  class: "row items-center"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "text-body1"
}
const _hoisted_6 = {
  key: 1,
  class: "text-body1 text-grey"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-grey" }, "@", -1)
const _hoisted_11 = { class: "q-mt-md q-gutter-sm" }
const _hoisted_12 = {
  key: 0,
  class: "text-negative q-mt-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_ctx.editing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.account.username)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " @" + _toDisplayString(_ctx.account.username), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, " Not set ")),
            (_ctx.account.profileUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  href: _ctx.account.profileUrl,
                  target: "_blank",
                  class: "q-ml-sm text-primary"
                }, [
                  _createVNode(_component_q_icon, {
                    name: "fa fa-external-link-alt",
                    size: "xs"
                  })
                ], 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_q_btn, {
              label: "Edit",
              color: "primary",
              flat: "",
              dense: "",
              "no-caps": "",
              onClick: _ctx.startEditing
            }, null, 8, ["onClick"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_q_input, {
            modelValue: _ctx.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
            label: "Username / Handle",
            loading: _ctx.saving,
            hint: "Enter the account username without the @ symbol",
            outlined: "",
            dense: "",
            onKeyup: _withKeys(_ctx.save, ["enter"])
          }, {
            prepend: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["modelValue", "loading", "onKeyup"]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_q_btn, {
              label: "Save",
              color: "primary",
              loading: _ctx.saving,
              disable: _ctx.saving,
              "no-caps": "",
              onClick: _ctx.save
            }, null, 8, ["loading", "disable", "onClick"]),
            _createVNode(_component_q_btn, {
              label: "Cancel",
              color: "grey",
              flat: "",
              disable: _ctx.saving,
              "no-caps": "",
              onClick: _ctx.cancel
            }, null, 8, ["disable", "onClick"])
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ]))
  ]))
}